import React, { useEffect, useState } from "react";
import dummyImg from "../../assets/images/dummy.png";
import { CircularProgressbar } from "react-circular-progressbar";
import { useDispatch, useSelector } from "react-redux";
import { getAllStudentApprovedCertificatesAPI } from "../../redux/features/studentDetailSlice";
import toast from "react-hot-toast";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

const AttestedCertificatesTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [certificatesRequests, setCertificateRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredStatus, setFilteredStatus] = useState("all");
  const [error, setError] = useState(null);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const res = await dispatch(
        getAllStudentApprovedCertificatesAPI({ token: auth.token })
      ).unwrap();
      if (res.success) {
        setCertificateRequests(res.data);
      }
    } catch (error) {
      toast.error(error || "Failed to fetch data", { position: "top-center" });
      setError(error || "Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, auth.token]);

  const filteredCertificates = certificatesRequests.filter((item) => {
    if (filteredStatus === "all") return true;
    return item.status?.toLowerCase() === filteredStatus;
  });

  const totalPages = Math.ceil(filteredCertificates.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentCertificateRequests = filteredCertificates.slice(
    startIndex,
    endIndex
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      ) : (
        <>
          <div className="d-flex justify-content-between align-content-center mb-16">
            <h2 className="ah-heading-04 fw-bold text-black mb-0">
              Certificates
            </h2>
            <div>
              <select
                name="status"
                className="form-control"
                value={filteredStatus}
                onChange={(e) => {
                  setFilteredStatus(e.target.value);
                }}
              >
                <option value="all">All</option>
                <option value="approved">Approved</option>
                <option value="completed">Completed</option>
              </select>
            </div>
          </div>

          <div className="card-default-style px-14 py-14 py-sm-40">
            <div className="align-item-center justify-content-between d-flex d-sm-none">
              <label className="me-2 flex-shrink-0 align-self-center">
                No of Rows
              </label>
              <select
                className="form-control ms-16"
                value={rowsPerPage}
                onChange={handleRowsChange}
                style={{ width: "100px" }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={40}>40</option>
                <option value={50}>50</option>
              </select>
            </div>

            <div className="table-responsive mb-10">
              <table className="table student-table custom-table align-middle">
                <thead className="position-sticky top-0">
                  <tr>
                    <th className="ah-text-base">Sr No.</th>
                    <th className="ah-text-base">Name</th>
                    <th className="ah-text-base">Course Name</th>
                    <th className="ah-text-base" width="20%">
                      Marks
                    </th>
                    <th className="ah-text-base" width="15%">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentCertificateRequests.length > 0 ? (
                    currentCertificateRequests.map((items, index) => (
                      <tr key={items.id}>
                        <td>
                          <div className="counter-block">
                            {startIndex + index + 1}
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="img-holder me-15">
                              <Image
                                src={
                                  (items?.student?.profile_picture || items?.user?.profile_picture)
                                    ? process.env.REACT_APP_GALLERY_URL +
                                    (items?.student?.profile_picture || items?.user?.profile_picture)
                                    : dummyImg
                                }
                                alt="items"
                                className="img-fluid h-100 w-100"
                                onError={(e) => {
                                  e.target.onError = null;
                                  e.target.src = dummyImg;
                                }}
                              />
                            </div>
                            <strong className="ah-text-sm fw-semibold">
                              {items?.student?.name || items?.user?.fullName || items?.user?.name || "N/A"}
                            </strong>
                          </div>
                        </td>
                        <td className="fw-semibold">
                          <div
                            className="text-truncate"
                            style={{ maxWidth: "400px" }}
                          >
                            {items?.courseTitle}
                          </div>
                        </td>
                        <td className="fw-semibold">
                          <CircularProgressbar
                            className="progress-circle-holder"
                            value={parseInt(items?.percentage)}
                            strokeWidth={16}
                            text={items?.percentage + "%"}
                            styles={{
                              path: {
                                stroke:
                                  parseInt(items.percentage) === 100
                                    ? "#82BD00"
                                    : "#F05203",
                              },
                              trail: {
                                stroke:
                                  parseInt(items.percentage) === 100
                                    ? "#E3EBD6"
                                    : "#F0520333",
                              },
                              text: {
                                fill: "#000",
                                fontSize: "22px",
                              },
                            }}
                          />
                        </td>
                        <td className="fw-semibold">
                          <Link
                            className="btn btn-primary no-shadow ah-text-sm py-6 px-25"
                            style={{ minWidth: "150px" }}
                            to={`/student-certificates-detail?certificateId=${items.id}`}
                          >
                            View Certificate
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">
                        <div className="alert alert-info">
                          No attested certificates found.
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-center justify-content-sm-between align-items-center custom-pagination-holder">
              <div className="mx-auto">
                <button
                  className="me-2 border-0 bg-transparent p-0 "
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Prev
                </button>
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    className={`bg-transparent border-0 ${currentPage === i + 1
                      ? "pagination-item active"
                      : "pagination-item"
                      } me-2`}
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  className="me-2 border-0 bg-transparent p-0"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>

              {/* Rows per page */}
              <div className="align-item-center d-none d-sm-flex">
                <label className="me-2 flex-shrink-0 align-self-center">
                  No of Rows
                </label>
                <select
                  className="form-control ms-16"
                  value={rowsPerPage}
                  onChange={handleRowsChange}
                  style={{ width: "100px" }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AttestedCertificatesTable;